import './BetbookLobby.less';

import React from 'react';
import BetbookTile from 'nike-ui/src/components/betbook-tiles/views/BetbookTile';
import i18n from '@i18n';
import { COMMUNITY_ANALYSES, BETBOOK_TICKETS, COMMUNITY_CHAT } from '@/routing/routes';
import BetbookAnalysisIcon from 'nike-ui/src/icons/svg/betbook-analysis-icon-sv.svg';
import BetbookTicketIcon from 'nike-ui/src/icons/BetbookTicketicon';
import ChatIcon from 'nike-ui/src/icons/svg/empty-chat-icon-sv.svg';
import MyBetbook from '@/betbook/views/MyBetbook';
import BetbookSections from '@/betbook/views/BetbookSections';
import { POST_ANALYSIS, POST_TICKET, toBetbookPathParams } from 'nike-ui/src/components/betbook/constants';
import FloatingButton from 'nike-ui/src/components/floating-button/FloatingButton';
import { navigate } from '@/routing';
import clsx from 'clsx';
import { useBetslipActive } from '@/betbook/utils';

function BetbookLobby() {
    const betslipActive = useBetslipActive();

    function handleChat() {
        navigate(COMMUNITY_CHAT);
    }

    return (
        <div className={clsx('pt-10 pb-20 px-20', { 'betslip-visible': betslipActive })}>
            <div className="flex flex-gap-5">
                <BetbookTile
                    route={BETBOOK_TICKETS}
                    params={toBetbookPathParams(POST_TICKET)}
                    label={i18n('betbook.tile.tickets')}
                    icon={<BetbookTicketIcon />}
                    data-atid="betbook-tickets-tile"
                />
                <BetbookTile
                    route={COMMUNITY_ANALYSES}
                    params={toBetbookPathParams(POST_ANALYSIS)}
                    label={i18n('betbook.tile.analysis')}
                    icon={<BetbookAnalysisIcon />}
                    data-atid="betbook-analyses-tile"
                />
                <BetbookTile
                    route={COMMUNITY_CHAT}
                    label={i18n('betbook.tile.chat')}
                    icon={<ChatIcon />}
                    data-atid="betbook-chat-tile"
                />
            </div>
            <BetbookSections />
            <MyBetbook />
            <div className="betbook-posts">
                <FloatingButton onClick={handleChat} dataAtid="betbook-new-post" isChat />
            </div>
        </div>
    );
}

export default BetbookLobby;
